import { render, staticRenderFns } from "./DualAxisParameterTrendPanel.vue?vue&type=template&id=006fd9df"
import script from "./DualAxisParameterTrendPanel.vue?vue&type=script&lang=js"
export * from "./DualAxisParameterTrendPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports